import { ScrollView, View } from 'smoothie';

import BankingOverview from '../../../banking/components/BankingOverview';
import LegacyBankingOverview from '../../../banking/components/LegacyBankingOverview';
import {
    BankingExperience,
    useBankingExperience,
} from '../../../common/providers/BankingExperienceProvider';

// This is not the true banking home route -- that is /home/banking,
// which is part of the layout that has Navigation and other components.
// This route is used for loading the banking experience outside of the
// normal app/nav context. This is necessary for users whose access is
// restricted to only banking features (i.e. non-member joint account holders).
export default function BankingOverviewScreen() {
    const { bankingExperience } = useBankingExperience();

    return (
        <ScrollView width="100%">
            <View
                width="100%"
                minHeight={500}
                $sm={{
                    maxWidth: 700,
                    alignSelf: 'center',
                }}
            >
                {bankingExperience === BankingExperience.CASH_CARD_ACCT ? (
                    <BankingOverview includeHeader={false} />
                ) : (
                    <LegacyBankingOverview includeHeader={false} />
                )}
            </View>
        </ScrollView>
    );
}
